// Help brought up to date with main: sidebar names, owner refund, import review, test mode, welcome email, Export Firm Data, eCheck, decline sentences, firm time zone, MightyExchange documents, the emailed staff setup link, client Stay logged in, and content pages opened from the dashboard. index.json keywords updated in lockstep. Delivered 2026-11-02.
// Payment, refund, and accounting dates use the firm's time zone (America/New_York when the firm record has none). This year and Last 30 days are firm-local days. Keywords updated in lockstep. Delivered 2026-11-02.
// Declined LawPay charges: client-portal, lawpay-payments, and billing-invoices say the portal shows LawPay's sentence (Your card was declined. Nothing was charged.) and that a full refund still sends amount and reason. Keywords updated in lockstep. Delivered 2026-11-01.
// Portal eCheck: lawpay-payments, client-portal, billing-invoices, data-security, and lawpay-connect describe one-time eCheck, Submit Payment, the 8am authorization, and the unavailable notice. Keywords updated in lockstep. Delivered 2026-11-01.
// Payments, invoices, and accounting articles note that those tables stay inside the card and scroll sideways on a narrow window. Delivered 2026-11-01.
// LawPay dashboard refunds and voids: lawpay-payments, client-portal, and billing-invoices describe status Refunded / Partially refunded and one line per refund (amount, method, date, invoice reversed). index.json keywords updated in lockstep — delivered 2026-11-01
// pkg195 — import-payments article corrected to the merged backend: duplicates and payments before the signed agreement are not saved; a typed agreement date or a chosen client is sent back through preview and the row moves; Confirm import saves only the checked Will import rows — delivered 2026-10-31
// pkg195 — import-payments article (Money): owner CSV import at /admin/accounting/import. accounting notes the page. index.json regenerated in lockstep (D-92g) — delivered 2026-10-31
// pkg198 — lawpay-payments, lawpay-connect, client-portal, billing-invoices, and data-security cover saved methods, autopay, payment plans, and retainer replenishment (test mode). index.json keywords updated in lockstep — delivered 2026-11-01
// pkg193 — accounting article added (Money): firm operating + trust totals, per-client table, activity; routes /admin/accounting. billing-invoices and lawpay-payments note the Accounting page, the payments date range, and the account filter. index.json regenerated in lockstep (D-92g) — delivered 2026-10-31
// pkg192 — staff-permissions notes that full agent access (Hanzelik) replaces the Agent padlocks with the same toggles Staff uses for Manage Staff, Mass Email, Clio Import, and Purchase Subscriptions & Credits; owner-only actions stay locked. Article set unchanged — delivered 2026-10-31
// pkg191 — data-security gains a 'How long you stay signed in' section; keywords gain session / logged out / stay logged in / sign out / timeout; index.json regenerated in lockstep (D-92g) — delivered 2026-10-31
// pkg189 — staff-permissions gains the AI agent accounts section; keywords gain agent / ai agent / grok bot / bot / ai assistant; index.json regenerated in lockstep (D-92g) — delivered 2026-10-31
// pkg173b — LawPay help: lawpay-connect (owner; routes Firm Settings) + lawpay-payments (staff; routes Payments, invoice detail, client detail) added to the Money section; client-portal, billing-invoices, trust-accounting, data-security articles gain LawPay sections/pointers; index.json regenerated in lockstep (D-92g) — delivered 2026-10-04
// pkg160/pkg161 — discovery-analysis keywords gain audio/video (refused), large production, batch upload, 2GB, file size; index.json updated in lockstep (pkg92) — delivered 2026-08-20
// pkg150 — discovery-analysis keywords gain 'criminal defense' + 'prosecution' (Criminal Defense Analysis rename); index.json updated in lockstep (pkg92) — delivered 2026-08-16
// pkg149 — discovery-analysis keywords gain the seven new report kinds (medical records, communications/texts, transactions/transfers, employment, criminal, contract/change orders/construction, payment history); index.json updated in lockstep (pkg92) — delivered 2026-08-16
// pkg143 — MOBILE-HIDDEN FLAG (App Store 3.1.1/3.1.3(c) remediation, companion to pkg142a): credits-pricing + wallet-referrals gain mobileHidden:true — the mobile Help center filters them out (pricing/purchase content must not be reachable in the iOS app); the web Help drawer ignores the key and still serves both. index.json updated in lockstep (D-92g) — delivered 2026-08-10
// pkg141 — discovery-analysis keywords gain custom inquiry / custom report / prompt (the new Custom Inquiry kind) + doc (legacy Word now accepted); index.json updated in lockstep — delivered 2026-08-09
// pkg132 — MOBILE MANIFEST LOCKSTEP: public/help/index.json is the mobile app's copy of this manifest (id/title/section/summary/keywords, generated from this file). D-92g EXTENDED: any change to the article set or titles updates helpIndex.js AND public/help/index.json in the SAME delivery — delivered 2026-07-26
// pkg98b — help branding sweep (the carried pkg91b candidate, done at Ryan's direction): ™ on every branded drawer title; article H1s + bodies rebranded (MightyAnalyzer / MightyDiscovery), ™ at first use per article — delivered 2026-07-18
// MightyExchange phase 1: mightyexchange rewritten for scan/convert/attest; mightyexchange-rejected and mightyexchange-adopt added. index.json updated in lockstep. Delivered 2026-11-02.
// pkg98 — MightyExchange entry added (community module exchange) + article public/help/mightyexchange.md (D-92g: manifest updated in the same delivery) — delivered 2026-07-18
// pkg91a — help entries follow the reassignment: MightyAnalyzer (production analysis) + MightyDiscovery drafting & responses; both searchable under old and branded terms — delivered 2026-07-18
// pkg91 — Help drawer entry retitled MightyDiscovery (Discovery Analysis) + mightydiscovery search keyword; article bodies untouched — delivered 2026-07-18
// pkg92 — the Help drawer's manifest (D-92a/c/d): one entry per article in
// /public/help/*.md. `routes` are substrings matched against the current
// pathname to drive the "For this page" section (D-92d); `keywords` feed
// search alongside the title, summary, and (once fetched) the body.
// STANDING RULE (D-92g): any package that changes a workflow updates its
// article — and this manifest if the article set changes — in the SAME
// delivery.

// Password setup page, client Stay logged in, and content-module links: staff-permissions and getting-started describe the setup email; client-portal notes the 48-hour stay-signed-in box; modules-jurisdictions notes that content pages open from the client dashboard and sidebar. index.json keywords updated in lockstep. Delivered 2026-11-02.

const HELP_INDEX = [
  // ── Getting started ────────────────────────────────────────────────────
  {
    id: 'getting-started',
    title: 'Your first client',
    section: 'Getting started',
    summary: 'Create a client, send the portal invite, and what happens next',
    keywords: ['create client', 'new client', 'welcome', 'welcome email', 'temporary password', 'temp password', 'invite', 'start', 'onboarding', 'first', 'setup email', 'password'],
    routes: ['/admin/create-client', '=/admin/dashboard'], // '=' prefix = exact match (pkg92)
  },
  {
    id: 'client-portal',
    title: 'What your client sees',
    section: 'Getting started',
    summary: 'The client portal from their side of the screen',
    keywords: ['client portal', 'client view', 'client login', 'portal', 'what clients see', 'payment methods', 'autopay', 'payment plan', 'saved card', 'bank account', 'test mode', 'stay logged in', '48 hours', 'refund', 'refunded', 'partially refunded', 'echeck', 'submit payment', 'authorization', 'declined', 'nothing was charged', 'content page'],
    routes: ['/admin/clients/'],
  },
  {
    id: 'clients-intake',
    title: 'Clients, contacts & conflicts',
    section: 'Getting started',
    summary: 'Managing client files, contacts, conflict checks, and closed files',
    keywords: ['clients', 'contacts', 'conflict check', 'closed files', 'archive', 'intake', 'mass email', 'welcome email', 'clio import', 'import contacts'],
    routes: ['/admin/clients', '/admin/closed-files', '/admin/dashboard/contacts', '/admin/dashboard/conflict-check'],
  },

  // ── Modules & documents ────────────────────────────────────────────────
  {
    id: 'modules-jurisdictions',
    title: 'Modules & jurisdictions',
    section: 'Modules & documents',
    summary: 'Which sections your clients see, and how your firm\u2019s states control the built-ins',
    keywords: ['modules', 'jurisdiction', 'states', 'built-in', 'content module', 'content page', 'practice areas', 'case types'],
    routes: ['/admin/dashboard/modules', '/admin/dashboard/practice-areas'],
  },
  {
    id: 'mightyexchange',
    title: 'MightyExchange\u2122 (community documents)',
    section: 'Modules & documents',
    summary: 'Scan, convert, and share a dynamic document, or adopt one from another firm',
    keywords: ['mightyexchange', 'exchange', 'community', 'dynamic document', 'share document', 'scan', 'convert', 'attestation', 'adopt', 'library'],
    routes: ['/admin/dashboard/exchange'],
  },
  {
    id: 'mightyexchange-rejected',
    title: 'Why a MightyExchange document was rejected',
    section: 'Modules & documents',
    summary: 'The review note on a rejected listing, and how to resubmit',
    keywords: ['mightyexchange', 'rejected', 'review note', 'resubmit', 'declined'],
    routes: ['/admin/dashboard/exchange'],
  },
  {
    id: 'mightyexchange-adopt',
    title: 'Adopting a MightyExchange document',
    section: 'Modules & documents',
    summary: 'A free copy, including the shared document when the listing has one, ready to fill',
    keywords: ['mightyexchange', 'adopt', 'has document', 'fill', 'dynamic document'],
    routes: ['/admin/dashboard/exchange', '/admin/dashboard/hq/exchange'],
  },
  {
    id: 'document-assembly',
    title: 'Document Modules & assembly',
    section: 'Modules & documents',
    summary: 'Build form modules, collect answers, and generate finished Word documents',
    keywords: ['document modules', 'assembly', 'templates', 'forms', 'signature', 'acknowledgment', 'generate'],
    routes: ['/admin/dashboard/firm-modules'],
  },

  // ── Discovery ──────────────────────────────────────────────────────────
  {
    id: 'discovery-drafting',
    title: 'MightyDiscovery\u2122 drafting & responses',
    section: 'Discovery',
    summary: 'Drafting the discovery you serve, and answering the discovery served on you',
    keywords: ['discovery', 'interrogatories', 'requests for production', 'responses', 'objections', 'ai discovery', 'mightydiscovery', 'draft'],
    routes: ['/admin/dashboard/ai-discovery', '/admin/dashboard/discovery-responses', '/admin/dashboard/discovery-sets', '/admin/dashboard/discovery-settings'],
  },
  {
    id: 'discovery-analysis',
    title: 'MightyAnalyzer\u2122 (production analysis)',
    section: 'Discovery',
    summary: 'Drop a production, pick reports, and what each one does',
    keywords: ['discovery analysis', 'mightyanalyzer', 'production', 'deficiency', 'income', 'assets', 'timeline', 'exhibit', 'analyze', 'custom inquiry', 'custom report', 'prompt', 'doc', 'medical records', 'communications', 'texts', 'transactions', 'transfers', 'employment', 'criminal', 'criminal defense', 'prosecution', 'contract', 'change orders', 'construction', 'payment history', 'video', 'audio', 'file size', 'large production', 'upload limit', '2gb'], // pkg160/161 — media refused, batched upload; pkg149 — seven new report kinds; pkg150 — Criminal Defense Analysis rename
    routes: ['discovery-analysis'],
  },
  {
    id: 'credits-pricing',
    title: 'Credits & pricing, in plain English',
    section: 'Discovery',
    summary: 'How report prices are built and what the numbers mean',
    keywords: ['credits', 'pricing', 'price', 'quote', 'cost', 'charge', 'pack'],
    routes: ['discovery-analysis', '/admin/dashboard/firm-wallet'],
    mobileHidden: true, // pkg143 — pricing content stays off the mobile app
  },

  // ── Money ──────────────────────────────────────────────────────────────
  {
    id: 'time-tracking',
    title: 'Time & expenses',
    section: 'Money',
    summary: 'Logging time, rates, and expenses that flow onto invoices',
    keywords: ['time', 'log time', 'hours', 'rates', 'expenses', 'billable'],
    routes: ['/admin/dashboard/log-time'],
  },
  {
    id: 'billing-invoices',
    title: 'Invoices & payments',
    section: 'Money',
    summary: 'Turning time and expenses into invoices, and recording payments',
    keywords: ['invoices', 'billing', 'payments', 'refunds', 'partial refund', 'refunded', 'partially refunded', 'void', 'generate invoice', 'lawpay link', 'accounting', 'payment plan', 'autopay', 'echeck', 'submit payment', 'declined', 'nothing was charged', 'time zone', 'eastern'],
    routes: ['/admin/dashboard/invoices'],
  },
  {
    id: 'lawpay-connect',
    title: 'Connecting LawPay',
    section: 'Money',
    summary: 'Connect your LawPay account, map operating/trust/eCheck, test vs live, surcharges',
    keywords: ['lawpay', 'connect lawpay', 'card payments', 'credit card', 'echeck', 'ach', 'account mapping', 'operating account', 'trust account', 'test mode', 'live mode', 'surcharge', 'payment processor', 'autopay', 'retainer replenishment', 'bank account', 'submit payment'],
    routes: ['/admin/dashboard/firm-settings'],
  },
  {
    id: 'lawpay-payments',
    title: 'Getting paid with LawPay',
    section: 'Money',
    summary: 'Send a pay link, request a retainer, the Payments page, and what Processing means',
    keywords: ['lawpay', 'pay link', 'send lawpay link', 'request retainer', 'retainer by card', 'payments page', 'processing', 'cleared', 'reversed', 'chargeback', 'refund', 'partial refund', 'confirm refund', 'refunded', 'partially refunded', 'void', 'client paid online', 'operating', 'account filter', 'date range', 'this year', 'all time', 'autopay', 'payment plan', 'saved card', 'saved payment method', 'test mode', 'echeck', 'submit payment', 'bank account', 'authorization', 'declined', 'nothing was charged', 'time zone', 'eastern'],
    routes: ['/admin/dashboard/payments', '/admin/dashboard/invoices/', '/admin/clients/'],
  },
  {
    id: 'trust-accounting',
    title: 'Trust accounting',
    section: 'Money',
    summary: 'The trust ledger, and the rules the platform enforces for you',
    keywords: ['trust', 'iolta', 'retainer', 'trust ledger', 'client funds'],
    routes: ['/admin/dashboard/trust'],
  },
  {
    id: 'accounting',
    title: 'Accounting',
    section: 'Money',
    summary: 'Operating and trust together: firm totals, each client, and the activity behind them',
    keywords: ['accounting', 'operating', 'trust', 'deposits', 'operating account', 'received', 'disbursed', 'trust balance', 'activity', 'csv', 'export', 'import payments', 'time zone', 'eastern', 'payment date'],
    routes: ['/admin/accounting'],
  },
  {
    id: 'import-payments',
    title: 'Import payments',
    section: 'Money',
    summary: 'Bring in a spreadsheet of payments you have already received, then review before saving',
    keywords: ['import payments', 'csv', 'spreadsheet', 'accounting email log', 'duplicates', 'agreement date', 'client match', 'confirm import', 'refund row', 'thread id'],
    routes: ['/admin/accounting/import'],
  },
  {
    id: 'wallet-referrals',
    title: 'Firm Wallet, credits & referrals',
    section: 'Money',
    summary: 'Buying credit packs, referral rewards, and your transaction history',
    keywords: ['wallet', 'buy credits', 'packs', 'referral', 'refer', 'balance', 'subscription'],
    routes: ['/admin/dashboard/firm-wallet', '/admin/dashboard/firm-billing'],
    mobileHidden: true, // pkg143 — purchase/referral content stays off the mobile app
  },

  // ── Your firm ──────────────────────────────────────────────────────────
  {
    id: 'staff-permissions',
    title: 'Staff, roles & ethical walls',
    section: 'Your firm',
    summary: 'Adding staff and AI agent accounts, what each permission unlocks, and walling staff off from a client',
    keywords: ['staff', 'permissions', 'roles', 'ethical wall', 'activity log', 'invite staff', 'temporary password', 'setup email', 'reset password', 'password', 'agent', 'ai agent', 'grok bot', 'bot', 'ai assistant'],
    routes: ['/admin/dashboard/staff', '/admin/dashboard/roles', '/admin/dashboard/activity-log'],
  },
  {
    id: 'firm-settings',
    title: 'Firm settings & branding',
    section: 'Your firm',
    summary: 'Firm name, jurisdictions, practice areas, and how your portal is addressed',
    keywords: ['firm settings', 'branding', 'subdomain', 'firm name', 'jurisdictions', 'settings', 'export', 'automatic payments', 'lawpay'],
    routes: ['/admin/dashboard/firm-settings'],
  },
  {
    id: 'data-security',
    title: 'Your data & security',
    section: 'Your firm',
    summary: 'How firm data is isolated, what AI features do with documents, and your export right',
    keywords: ['security', 'data', 'privacy', 'export', 'export firm data', 'confidential', 'isolation', 'card data', 'pci', 'lawpay', 'session', 'logged out', 'stay logged in', 'sign out', 'timeout', '30 days', '48 hours', 'echeck', 'routing number', 'bank account'],
    routes: [],
  },
  {
    id: 'support',
    title: 'Getting support',
    section: 'Your firm',
    summary: 'How to reach us, and what to include so we can fix it fast',
    keywords: ['support', 'help', 'contact', 'bug', 'problem', 'email'],
    routes: [],
  },
];

export default HELP_INDEX;
